import { EQUIVALENT_VALUELESS_MATCH_MODE } from '../../constants';
import { FilterItemType, FilterType, MatchMode } from '../../types/types';
import { getDefaultMatchMode } from '../getDefaultMatchMode';
import { getFilterMatchModes } from './getFilterMatchModes';
import { isValuelessMatchMode } from './isValuelessMatchMode';

export const getSupportedDefaultMatchMode = (
  filterItem: FilterItemType,
  fallbackType?: string
): MatchMode => {
  const matchMode = getDefaultMatchMode(filterItem);

  const itemMatchModes = getFilterMatchModes(filterItem);
  const availableMatchModes =
    itemMatchModes.length > 0
      ? itemMatchModes
      : getFilterMatchModes(filterItem, fallbackType);

  if (availableMatchModes.length === 0) {
    return matchMode;
  }

  if (availableMatchModes.some(({ name }) => name === matchMode)) {
    return matchMode;
  }

  const equivalentMatchMode = EQUIVALENT_VALUELESS_MATCH_MODE[matchMode];
  if (
    equivalentMatchMode &&
    availableMatchModes.some(({ name }) => name === equivalentMatchMode)
  ) {
    return equivalentMatchMode;
  }

  // Valueless modes stay valid on types that offer neither family (boolean, checkbox, reference)
  if (isValuelessMatchMode(matchMode)) {
    return matchMode;
  }

  // Ignore the server default and re-derive from the type that drives the offered modes
  const typeMatchMode = getDefaultMatchMode({
    ...filterItem,
    type:
      itemMatchModes.length > 0
        ? filterItem.type
        : (fallbackType as FilterType | undefined),
    default: undefined,
  });

  if (availableMatchModes.some(({ name }) => name === typeMatchMode)) {
    return typeMatchMode;
  }

  return availableMatchModes[0].name as MatchMode;
};
